import { render, staticRenderFns } from "./FinancialInstrumentForm.vue?vue&type=template&id=dc22a228&scoped=true&"
import script from "./FinancialInstrumentForm.vue?vue&type=script&lang=ts&"
export * from "./FinancialInstrumentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc22a228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
